import { DataTable } from 'components';
import { DataTableColumn } from 'components/tables/data-table';
import { useSelectedLocation } from 'contexts';
import useTimeZone from 'hooks/use-timezone';
import { FC, useState } from 'react';
import { listDailyEdiCustomerLog } from 'services/edi-dashboard';

const EdiDashboard: FC = () => {
    const { selectedLocation } = useSelectedLocation();
    const { newZonedDayJs, zonedStartOfDay, zonedEndOfDay } = useTimeZone();

    const [startDate, setStartDate] = useState<string>(newZonedDayJs().toISOString().substring(0, 10));
    const [endDate, setEndDate] = useState<string>(newZonedDayJs().toISOString().substring(0, 10));

    // useEffect(() => console.log(startDate, endDate), [startDate, endDate]);
    // useEffect(() => console.log(newZonedDayJs(startDate).startOf('day').toISOString(), newZonedDayJs(endDate).endOf('day').toISOString()), [startDate, endDate]);

    return (
        <div className="page" id="edi-dashboard" data-cy="edi-dashboard">
            <div className="page-header">
                <h1>EDI DASHBOARD</h1>
                <div className="date-range d-flex flex-fill g-3 justify-content-center">
                    <input
                        type="date"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                    />
                    <h1>-</h1>
                    <input
                        type="date"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                    />
                </div>
            </div>
            <div className="flex-fill">
                <DataTable
                    tableClass="t-height"
                    fetchData={() => listDailyEdiCustomerLog(
                        zonedStartOfDay(startDate).toISOString(),
                        zonedEndOfDay(endDate).endOf('day').toISOString(),
                        selectedLocation?.id
                    )}
                    columns={columns}
                    initialPage={{ pageNum: 0, pageSize: 100, sortField: 'customer', sortDirection: 'desc' }}
                    initialColumns={columns}
                    filterByLocation
                    data-cy="edi-dashboard-table"
                />
            </div>
        </div>
    );
}

const columns: DataTableColumn[] = [
    {
        field: 'customer',
        getValueLabel: (c) => c.name,
        label: "CUSTOMER"
    },
    {
        field: 'gateEdiCount',
        label: 'GATE EDI'
    },
    {
        field: 'gateCount',
        label: 'GATES'
    },
    {
        field: 'liftEdiCount',
        label: 'LIFT EDI'
    },
    {
        field: 'liftCount',
        label: 'LIFTS'
    },
    {
        field: 'statusEdiCount',
        label: 'STATUS EDI'
    },
    {
        field: 'statusCount',
        label: 'STATUSES'
    },
    {
        field: 'bookingEdiCount',
        label: 'BOOKING EDI'
    },
    {
        field: 'bookingCount',
        label: 'BOOKINGS'
    },
];

export default EdiDashboard;